import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Setting } from '../DTO/setting';
import { SettingModel } from '../models/setting.model';
import { SettingConverter } from '../converters/setting.converter';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private _setting: SettingModel;
  // per i processi warp che non hanno bisogno del titolo della sezione del menu
  warpProcess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private settingConverter: SettingConverter,
    private configurationService: ConfigurationService
  ) { }

  private getBaseResourceEndpoint(): string {
    return (
      this.configurationService.configuration.api.setting
    );
  }

  get setting(): SettingModel {
    return this._setting;
  }

  set setting(value: SettingModel) {
    this._setting = value;
  }

// saveSetting(setting: Setting) {
  //   if (this.setting) {
  //     this.dbService.update('setting', setting).then(s => {
  //       this.setting = setting;
  //       console.log('update setting', this.setting);
  //     });
  //   } else {
  //     this.dbService.add('setting', setting).then(s => {
  //       this.setting = setting;
  //       console.log('add setting', this.setting);
  //     });
  //   }
  // }

  // loadConfiguration(): Promise<Setting> {
  //   return this.dbService.getAll('setting').then(setting => {
  //     if (setting.length < 1) {
  //       console.log('nessuna configurazione trovata');
  //       this.setDefaultSetting();
  //     } else {
  //       console.log('configurazione trovata', setting);
  //       this.setting = setting[0];
  //     }
  //     return this.setting;
  //   });
  // }

  // setDefaultSetting() {
  //   this.setting = {};
  //   this.setting.layout = {};
  //   this.setting.global = {};
  //
  //   this.setting.global.language = 'it';
  //   this.setting.layout.allAccordionOpen = false;
  //   this.setting.layout.tabMode = false;
  // }

  // clearConfiguration() {
  //   this.dbService.clear('setting');
  // }

  loadSetting(): Observable<SettingModel> {
    const url = this.getBaseResourceEndpoint();
    return this.http.get(url).pipe(
      map((dtos: Setting) => {
        this.setting = this.settingConverter.convertToModel(dtos);
        // this.setting.layout.expandedMenu = true;
        return this.setting;
      }),
    );
  }

  saveSetting(setting: SettingModel): Observable<SettingModel> {
    const url = this.getBaseResourceEndpoint();
    const dto = this.settingConverter.convertToDto(setting);
    return this.http.put(url, dto).pipe(
      map((dtoUpdated: Setting) => {
        this.setting = this.settingConverter.convertToModel(dtoUpdated);
        return this.setting;
      }),
    );

  }
}
